<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      v-if="trendShow"
      row-key="UserId"
      ref="list"
      unit="用户"
      :show-summary="true"
      :expand-all-row="true"
      :page="true"
      :show-checkbox="false"
      :show-query="true"
      :get-data-func="api.getPuDocHistory"
      urlHash="business/purchase/history"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/pu/puDoc").default,
      trendShow: true,
      
    };
  },

  mounted() {
    // console.log("1");
    // 
    ;
    if (!this.$permission.canPrice("/business/purchase/history")) {
      const list = this.$refs.list;
      const findIndex0 = list.tableList.findIndex(item => item.tableName == "QuotedPrice");
      if (findIndex0 >= 0) list.tableList.splice(findIndex0, 1);
      const findIndex1 = list.tableList.findIndex(item => item.tableName == "Discount");
      if (findIndex1 >= 0) list.tableList.splice(findIndex1, 1);
      const findIndex2 = list.tableList.findIndex(item => item.tableName == "Price");
      if (findIndex2 >= 0) list.tableList.splice(findIndex2, 1);
      const findIndex3 = list.tableList.findIndex(item => item.tableName == "TaxRate");
      if (findIndex3 >= 0) list.tableList.splice(findIndex3, 1);
      const findIndex4 = list.tableList.findIndex(item => item.tableName == "TaxPrice");
      if (findIndex4 >= 0) list.tableList.splice(findIndex4, 1);
      const findIndex5 = list.tableList.findIndex(item => item.tableName == "Amount");
      if (findIndex5 >= 0) list.tableList.splice(findIndex5, 1);
      const findIndex6 = list.tableList.findIndex(item => item.tableName == "TaxLimit");
      if (findIndex6 >= 0) list.tableList.splice(findIndex6, 1);
      const findIndex7 = list.tableList.findIndex(item => item.tableName == "TaxAmount");
      if (findIndex7 >= 0) list.tableList.splice(findIndex7, 1);
    }
  },

  methods: {

    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map(x => x.tableName);
          var params = { ...listParams, Fields: fields.join(',') };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.historyExport(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>